import styled from "styled-components";

import { CategoriesTabsMobileStyledProps as Props } from "./CategoriesTabsMobile.types";
import { CategoriesTabsMobilePlaceholderStyledProps as PlaceholderProps } from "./CategoriesTabsMobile.types";
import CONSTANTS from "config/constants";

const { BREAKPOINTS } = CONSTANTS;
const { tablet, wide } = BREAKPOINTS;

const CategoriesTabsMobileStyled = styled.div<Props>`
  display: flex;
  align-items: center;
  padding-top: 1.2rem;
  padding: 1.2rem 1.6rem 0 1.6rem;
  background-color: var(--palette-white);
  overflow-x: scroll;
  scrollbar-color: var(--palette-gray-s0-l80) transparent;
  scrollbar-width: thin;

  @media (min-width: ${wide + 1}px) {
    justify-content: center;
  }

  @media (min-width: ${tablet + 1}px) {
    grid-area: content;
    padding-top: 2.4rem;
  }

  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }

  &::-webkit-scrollbar:vertical {
    width: 0.4rem;
  }

  &::-webkit-scrollbar-button:increment,
  &::-webkit-scrollbar-button {
    display: none;
  }

  &::-webkit-scrollbar:horizontal {
    height: 0.4rem;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--palette-gray-s0-l35);
    border-radius: 0.8rem;
    border: 2px solid var(--palette-gray-s0-l35);
  }

  &::-webkit-scrollbar-track {
    border-radius: 0.8rem;
  }

  .CategoriesTabsMobile {
    &__tabs {
      display: flex;
      padding-bottom: 1.2rem;

      & > *:not(:last-child) {
        margin-right: 1.6rem;
      }

      @media (min-width: ${tablet + 1}px) {
        & > *:not(:last-child) {
          margin-right: 2.4rem;
        }
      }
    }

    &__see-more {
      background-color: var(--palette-gray-s0-l98);
      font-size: 1.2rem;
      color: var(--palette-black-s0-l10);
      width: 16rem;

      & svg {
        transform: rotate(90deg);
      }
    }

    &__item {
      border: none;
      box-shadow: none;
      font-weight: 700;
      color: var(--palette-gray-s0-l50);
      width: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s;
      padding: 0.4rem;
      background-color: unset;
      white-space: nowrap;
      cursor: pointer;

      &.Button {
        background-color: var(--palette-white) !important;
        border-radius: 0;

        &:hover:not([disabled]) {
          box-shadow: none !important;
          border: none !important;
        }
      }

      & > *:not(:last-child) {
        margin-right: 0rem;
      }

      &:focus,
      &:hover,
      &:active {
        box-shadow: none;
        background-color: transparent;
      }

      &:focus-visible {
        box-shadow: none;
        outline: 0.1rem solid var(--palette-primary);
        outline-offset: -0.1rem;
      }

      &--active {
        color: var(--palette-primary);
        border-bottom: 0.2rem solid var(--palette-primary);

        & .CategoriesTabsMobile__item__text {
          color: var(--palette-primary);
        }
      }

      &.Button:hover {
        background-color: transparent;
        border: none;
        box-shadow: none;
      }

      &__text {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-align: center;
        color: var(--palette-gray-s0-l50);
        line-height: 1.6rem;
        font-size: 1.4rem;
      }
    }

    &__category {
      font-size: 1.6rem;
      font-weight: 700;
      font-family: var(--fonts-secondary);
      padding: 1.2rem 2rem;
      border-radius: 10rem;
      border: 2px solid var(--palette-grey-2);
      background-color: var(--palette-white);
      color: var(--palette-black4);
      margin: 0 0.8rem;
      height: 4.8rem;
      text-align: center;
      cursor: pointer;
      display: flex;
      align-items: center;

      &--active {
        border: 0;
        background-color: var(--palette-black4);

        & .CategoriesTabsMobile__category__link {
          color: var(--palette-white);
        }
      }

      &__link {
        color: var(--palette-black4);
        text-decoration: none;
      }
    }
  }
`;

const CategoriesTabsMobilePlaceholderStyled = styled.div<PlaceholderProps>`
  display: flex;
  width: 100%;
  height: 3.6rem;
  margin-bottom: 0.4rem;
  overflow: hidden;

  .CategoriesTabsMobilePlaceholder {
    &__item {
      background-color: var(--palette-gray-s0-l95);
      border-radius: 0.4rem;
      overflow: hidden;
      position: relative;
      height: 100%;
      min-width: 12.8rem;
      margin-right: 1.6rem;
    }
  }
`;

export { CategoriesTabsMobilePlaceholderStyled };

export default CategoriesTabsMobileStyled;
